// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    width: 100%;
    height: 100%;
}

.main-section {
    margin-left: 1.5%;
    margin-right: 2%;
    background: var(--primary-background);
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: var(--box-shadow);
    border-radius: 10px;
    width: 97%;
    height: 92%;
}

.split-section {
    background: transparent;
    width: 100%;
    height: 100%;
    display: flex;
}

.section {
    margin-left: 1%;
    background: var(--primary-background);
    border: var(--section-background);
    box-sizing: border-box;
    border-radius: 6px;
    height: 94%;
    width: 50%;
}

.vertical-section {
    background: var(--primary-background);
    border: var(--section-background);
    box-sizing: border-box;
    border-radius: 6px;
    height: 50%;
    width: 100%;
}

.section:last-child {
    margin-right: 1%;
}

.command-bar {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-height: 40%;
    padding: 1% 0.5%;
}

.command-bar .filter-grid-container {
    flex-grow: 3;
}

.command-bar .actions-section {
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    align-items: center;
}

.data-grid {
    height: 85%;
}

.data-grid .row-header {
    width: 98%;
    background: var(--row-header-background);
    box-shadow: 0px 3px 1px #8c8d8d;
    border-radius: 5px;
    display: flex;
    height: 10%;
    justify-content: center;
    align-items: center;
    margin: 0% 1%;
    font-size: larger;
    font-style: normal;
    font-weight: 600;
}

.data-grid .row-header.expand-section {
    text-align: center;
    background: var(--expanded-row-header-background);
    height: 15%;
    min-height: 4vh!important;
}

.data-grid .row-header .actions {
    text-align: center;
}

.data-grid .rows-container {
    height: 85%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
}

.data-grid .rows-container.expand-section {
    height: auto;
    margin-left: 1%;
    margin-right: 1%;
    background-color: var(--expanded-row-container-background);
    border-bottom: 1px solid var(--expanded-row-header-background);
}

.data-grid .rows-container .row {
    width: 98%;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0.5% 1%;
    padding: 0.5% 0;
}

.data-grid .rows-container .row .row-item {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 1%;
}

.data-grid .rows-container .row .actions {
    width: 10%;
    display: flex;
    justify-content: center;
}

.data-grid .rows-container .row input {
    width: 100%;
    text-align: center;
    min-height: 30px;
}

.data-grid .rows-container .row .actions:hover {
    cursor: pointer;
}

.data-grid .rows-container .row.colored {
    background: var(--row-color);
}

.data-grid .rows-container .row.highlight {
    background-color: var(--highlighted-color);
}

.icons:hover {
    cursor: pointer;
}

.buttons {
    opacity: 0.62;
    border-radius: 8px;
    color: white;
    display: flex;
    background: var(--link-active);
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    border: none;
    align-items: center;
    padding: 1.5vh 1vw;
    min-width: 10vw;
    justify-content: center;
    font-weight: 600;
}

.buttons:hover {
    cursor: pointer;
}
.buttons span {
    padding: 0 0.5vw;
}
.text-area {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.text-area textarea{
    width: 80%;
    min-height: 40px;
    text-align: center;
    padding: 1% 1%;
}


.data-tiles {
    border: 1px solid var(--expanded-row-header-background);
    display: flex;
    flex-direction: column;
    width: 20vw;
    height: 25vh;
    border-radius: 5px;
}

.data-tiles-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow-y: hidden;
}

.data-tiles-container.vertical {
    flex-direction: row!important;
}

.data-tile-header {
    background-color: var(--link-active);
    /* border: 1px solid var(--expanded-row-header-background); */
    height: 5vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.data-tile-item {
    width: 50%;
    border: 1px solid var(--expanded-row-header-background);
}

.breadcrumb {
    display: flex;
    position: relative;
    height: 2vw;
    margin: 0.5vh 0.5vw;
    color: white;
    font-weight: 600;
    font-size: large;
}

.breadcrumb::after {
    content: "";
    width: 0;
    height: 0;
    border-top: 1vw solid transparent;
    border-bottom: 1vw solid transparent;
    border-left: 2vw solid var(--expanded-row-header-background);
    position: absolute;
    z-index: 10;
    right: -2vw;
}

.breadcrumb.active::after {
    border-left: 2vw solid var(--highlighted-color);
}

.breadcrumb .content {
    background-color: var(--expanded-row-header-background);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1vh 1vw;
}

.breadcrumb.active .content.active {
    background-color: var(--highlighted-color);
    color: white;
}

.breadcrumb::before {
    content: "";
    width: 0;
    height: 0;
    border-top: 1vw solid var(--expanded-row-header-background);
    border-bottom: 1vw solid var(--expanded-row-header-background);
    border-left: 2vw solid transparent;
}

.breadcrumb.active::before {
    border-top: 1vw solid var(--highlighted-color);
    border-bottom: 1vw solid var(--highlighted-color);
}

.arrow-container {
    width: 10vw;
    height: 4vh;
    padding: 1vh 1vw;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    position: relative;
}

.arrow-container.left {
    direction: rtl;
}

.arrow-tails.left::after {
    content: "";
    width: 0;
    height: 0;
    border-top: 0.3vw solid transparent;
    border-bottom: 0.3vw solid transparent;
    border-right: 1vw solid black;
    border-left: none;
    position: absolute;
    z-index: 10;
    top: 1.4vh;
}

.arrow-length {
    width: 90%;
    border: 1px solid;
    margin: 2vh 0;
    background-color: black;
}

.arrow-tails {
    height: 100%;
}

.arrow-tails::after {
    content: "";
    width: 0;
    height: 0;
    border-top: 0.3vw solid transparent;
    border-bottom: 0.3vw solid transparent;
    border-left: 1vw solid black;
    position: absolute;
    z-index: 10;
    top: 1.4vh;
}`, "",{"version":3,"sources":["webpack://./src/components/components.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,oCAAoC;IACpC,6BAA6B;IAC7B,mBAAmB;IACnB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,iCAAiC;IACjC,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,iCAAiC;IACjC,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,wCAAwC;IACxC,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iDAAiD;IACjD,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,0DAA0D;IAC1D,8DAA8D;AAClE;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,oDAAoD;IACpD,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;;AAGA;IACI,uDAAuD;IACvD,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;IACpC,6DAA6D;IAC7D,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,uDAAuD;AAC3D;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,oCAAoC;IACpC,4DAA4D;IAC5D,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,uDAAuD;IACvD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;IAC1C,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,2DAA2D;IAC3D,8DAA8D;IAC9D,kCAAkC;AACtC;;AAEA;IACI,8CAA8C;IAC9C,iDAAiD;AACrD;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,mCAAmC;IACnC,sCAAsC;IACtC,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,mCAAmC;IACnC,sCAAsC;IACtC,4BAA4B;IAC5B,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd","sourcesContent":[".container {\n    width: 100%;\n    height: 100%;\n}\n\n.main-section {\n    margin-left: 1.5%;\n    margin-right: 2%;\n    background: var(--primary-background);\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    box-shadow: var(--box-shadow);\n    border-radius: 10px;\n    width: 97%;\n    height: 92%;\n}\n\n.split-section {\n    background: transparent;\n    width: 100%;\n    height: 100%;\n    display: flex;\n}\n\n.section {\n    margin-left: 1%;\n    background: var(--primary-background);\n    border: var(--section-background);\n    box-sizing: border-box;\n    border-radius: 6px;\n    height: 94%;\n    width: 50%;\n}\n\n.vertical-section {\n    background: var(--primary-background);\n    border: var(--section-background);\n    box-sizing: border-box;\n    border-radius: 6px;\n    height: 50%;\n    width: 100%;\n}\n\n.section:last-child {\n    margin-right: 1%;\n}\n\n.command-bar {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    max-height: 40%;\n    padding: 1% 0.5%;\n}\n\n.command-bar .filter-grid-container {\n    flex-grow: 3;\n}\n\n.command-bar .actions-section {\n    display: flex;\n    flex-grow: 1;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.data-grid {\n    height: 85%;\n}\n\n.data-grid .row-header {\n    width: 98%;\n    background: var(--row-header-background);\n    box-shadow: 0px 3px 1px #8c8d8d;\n    border-radius: 5px;\n    display: flex;\n    height: 10%;\n    justify-content: center;\n    align-items: center;\n    margin: 0% 1%;\n    font-size: larger;\n    font-style: normal;\n    font-weight: 600;\n}\n\n.data-grid .row-header.expand-section {\n    text-align: center;\n    background: var(--expanded-row-header-background);\n    height: 15%;\n    min-height: 4vh!important;\n}\n\n.data-grid .row-header .actions {\n    text-align: center;\n}\n\n.data-grid .rows-container {\n    height: 85%;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n}\n\n.data-grid .rows-container.expand-section {\n    height: auto;\n    margin-left: 1%;\n    margin-right: 1%;\n    background-color: var(--expanded-row-container-background);\n    border-bottom: 1px solid var(--expanded-row-header-background);\n}\n\n.data-grid .rows-container .row {\n    width: 98%;\n    border-radius: 5px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0.5% 1%;\n    padding: 0.5% 0;\n}\n\n.data-grid .rows-container .row .row-item {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    padding: 0 1%;\n}\n\n.data-grid .rows-container .row .actions {\n    width: 10%;\n    display: flex;\n    justify-content: center;\n}\n\n.data-grid .rows-container .row input {\n    width: 100%;\n    text-align: center;\n    min-height: 30px;\n}\n\n.data-grid .rows-container .row .actions:hover {\n    cursor: pointer;\n}\n\n.data-grid .rows-container .row.colored {\n    background: var(--row-color);\n}\n\n.data-grid .rows-container .row.highlight {\n    background-color: var(--highlighted-color);\n}\n\n.icons:hover {\n    cursor: pointer;\n}\n\n.buttons {\n    opacity: 0.62;\n    border-radius: 8px;\n    color: white;\n    display: flex;\n    background: var(--link-active);\n    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\n    border: none;\n    align-items: center;\n    padding: 1.5vh 1vw;\n    min-width: 10vw;\n    justify-content: center;\n    font-weight: 600;\n}\n\n.buttons:hover {\n    cursor: pointer;\n}\n.buttons span {\n    padding: 0 0.5vw;\n}\n.text-area {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.text-area textarea{\n    width: 80%;\n    min-height: 40px;\n    text-align: center;\n    padding: 1% 1%;\n}\n\n\n.data-tiles {\n    border: 1px solid var(--expanded-row-header-background);\n    display: flex;\n    flex-direction: column;\n    width: 20vw;\n    height: 25vh;\n    border-radius: 5px;\n}\n\n.data-tiles-container {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    overflow-y: hidden;\n}\n\n.data-tiles-container.vertical {\n    flex-direction: row!important;\n}\n\n.data-tile-header {\n    background-color: var(--link-active);\n    /* border: 1px solid var(--expanded-row-header-background); */\n    height: 5vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n}\n\n.data-tile-item {\n    width: 50%;\n    border: 1px solid var(--expanded-row-header-background);\n}\n\n.breadcrumb {\n    display: flex;\n    position: relative;\n    height: 2vw;\n    margin: 0.5vh 0.5vw;\n    color: white;\n    font-weight: 600;\n    font-size: large;\n}\n\n.breadcrumb::after {\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-top: 1vw solid transparent;\n    border-bottom: 1vw solid transparent;\n    border-left: 2vw solid var(--expanded-row-header-background);\n    position: absolute;\n    z-index: 10;\n    right: -2vw;\n}\n\n.breadcrumb.active::after {\n    border-left: 2vw solid var(--highlighted-color);\n}\n\n.breadcrumb .content {\n    background-color: var(--expanded-row-header-background);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 1vh 1vw;\n}\n\n.breadcrumb.active .content.active {\n    background-color: var(--highlighted-color);\n    color: white;\n}\n\n.breadcrumb::before {\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-top: 1vw solid var(--expanded-row-header-background);\n    border-bottom: 1vw solid var(--expanded-row-header-background);\n    border-left: 2vw solid transparent;\n}\n\n.breadcrumb.active::before {\n    border-top: 1vw solid var(--highlighted-color);\n    border-bottom: 1vw solid var(--highlighted-color);\n}\n\n.arrow-container {\n    width: 10vw;\n    height: 4vh;\n    padding: 1vh 1vw;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: none;\n    position: relative;\n}\n\n.arrow-container.left {\n    direction: rtl;\n}\n\n.arrow-tails.left::after {\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-top: 0.3vw solid transparent;\n    border-bottom: 0.3vw solid transparent;\n    border-right: 1vw solid black;\n    border-left: none;\n    position: absolute;\n    z-index: 10;\n    top: 1.4vh;\n}\n\n.arrow-length {\n    width: 90%;\n    border: 1px solid;\n    margin: 2vh 0;\n    background-color: black;\n}\n\n.arrow-tails {\n    height: 100%;\n}\n\n.arrow-tails::after {\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-top: 0.3vw solid transparent;\n    border-bottom: 0.3vw solid transparent;\n    border-left: 1vw solid black;\n    position: absolute;\n    z-index: 10;\n    top: 1.4vh;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
